const getRandomInt = (digits) => {
    // set min
    let min = 1; 
    for (let i = 1; i < digits; i++) {
        min = min * 10; 
    }
    // set max
    let max = 9; 
    for (let i = 1; i < digits; i++) {
        max = max * 10; 
    }
    // get random int 
    return Math.floor(min + Math.random() * max); 
}

export default getRandomInt; 